export enum SelectionType {
  MAP = 'map',
  LIST = 'list',
}
